<template>
  <div class="notification-center">
    <Notification
      v-for="(notification, index) in notifications"
      :key="notification.id"
      :notification="notification"
      :style="{ top: `${index * 140 + 20}px` }"
      @close="handleClose(notification.id)"
      @notification-click="handleNotificationClick(notification)"
    />
  </div>
</template>

<script>
import Notification from "./Notification.vue";

export default {
  name: "NotificationCenter",
  components: {
    Notification,
  },
  props: {
    notifications: {
      type: Array,
      required: true,
      default: () => [],
    },
    onClick: {
      type: Function,
      required: true,
      validator: (value) => {
        // 验证是否为函数
        const isValid = typeof value === "function";
        if (!isValid) {
          console.error("onClick必须是一个函数");
        }
        return isValid;
      },
    },
  },
  methods: {
    handleClose(id) {
      this.$emit("remove-notification", id);
    },
    handleNotificationClick(notification) {
      // 确保外部点击处理器存在且是函数
      if (typeof this.onClick === "function") {
        this.onClick(notification);
        // 添加调试日志
        console.log("Click handler called for notification:", notification.id);
      } else {
        console.error("onClick is not a function");
      }
    },
  },
};
</script>

<style scoped>
.notification-center {
  position: fixed;
  right: 10px;
  bottom: 10px;
  z-index: 9999;
  display: flex;
  flex-direction: column-reverse; /* 最新的通知在最下方 */
  align-items: flex-end;
}
</style>
